import React from 'react'

import { Progress } from 'antd'
import { Link, Text, VStack } from 'govwell-ui'
import { AICommunityAssistantUsageQuotaStatus } from 'types/graphql'

import AIAssistantUpsellModal from 'src/components/AIAssistant/AIAssistantUpsellModal'
import { useAICommunityAssistantUsageQuery } from 'src/fetch/aiChat'
import { useActiveOrgId } from 'src/hooks/use-active-org-id'
import useDisclosure from 'src/hooks/use-disclosure'

const ProgressBarColorForQuotaStatusMap: Record<AICommunityAssistantUsageQuotaStatus, string> = {
  UnderQuota: 'var(--color-blue-500)',
  NearOrAtQuota: 'var(--color-yellow-500)',
  OverQuota: 'var(--color-red-500)',
}

const AICommunityAssistantUsageFooter = () => {
  const organizationId = useActiveOrgId()
  const { aiCommunityAssistantUsage } = useAICommunityAssistantUsageQuery({
    organizationId,
    date: { type: 'ThisMonth' },
  })

  const upsellModalState = useDisclosure()

  if (!aiCommunityAssistantUsage?.quotaDetails) {
    return null
  }

  return (
    <VStack>
      <Progress
        percent={aiCommunityAssistantUsage.quotaDetails.percentUsed}
        showInfo={false}
        strokeColor={
          ProgressBarColorForQuotaStatusMap[aiCommunityAssistantUsage.quotaDetails.status]
        }
      />
      <VStack gap={1} className="p-2">
        <Text.Body>
          <strong>{aiCommunityAssistantUsage.quotaDetails.usedResponses}</strong>/
          {aiCommunityAssistantUsage.quotaDetails.allowedResponses} AI responses used this month
        </Text.Body>
        <Link onClick={upsellModalState.open}>
          {aiCommunityAssistantUsage.quotaDetails.status === 'OverQuota'
            ? `Your organization has exceeded its monthly limit for AI Community Assistant responses. Please upgrade to continue access.`
            : `Get unlimited responses`}
        </Link>
      </VStack>
      <AIAssistantUpsellModal
        isOpen={upsellModalState.isOpen}
        onClose={upsellModalState.close}
        tiers={aiCommunityAssistantUsage.tiers}
      />
    </VStack>
  )
}

export default React.memo(AICommunityAssistantUsageFooter)
